import empty_routes from "../modules/empty/router/routes";
import idom_routes from "../modules/idom/router/routes";
import loms_routes from "../modules/loms/router/routes";
import mediaplans_routes from "src/modules/mediaplans/router/routes";
import idom_settings_routes from "../modules/idom-settings/router/routes";
import cube_routes from "../modules/cube/router/routes";
import gmc_routes from "../modules/gmc/router/routes";
import sip_routes from "../modules/sip/router/routes";
import dataset_routes from "../modules/dataset/router/routes";
import ma_routes from "../modules/ma/router/routes";
import game_routes from "../modules/game/router/routes";
import kb_routes from "../modules/kb/router/routes";
import data_master_routes from "../modules/data_master/router/routes";
import operator_routes from "../modules/operator/router/routes";
import dsgraph_routes from "../modules/dsgraph/router/routes";
import chat_routes from "../modules/chat/router/routes";
import rec_routes from "../modules/rec/router/routes";
import tts_routes from "../modules/tts/router/routes";
import front_routes from "../modules/front/router/routes";
import integrations_routes from "../modules/integrations/router/routes";
import utils_routes from "../modules/utils/router/routes";
import idom_statistic_routes from "../modules/idom-statistic/router/routes";
import idom_mem_routes from "../modules/idom-mem/router/routes";
import idom_reaction_routes from "../modules/idom-reaction/router/routes";
import idom_tasks_routes from "../modules/idom-tasks/router/routes";
import { RouteRecordRaw } from "vue-router";

const routes: RouteRecordRaw[] = [
  {
    path: "/",
    component: () => import("layouts/MainLayout.vue"),
    children: [
      { path: "a", redirect: { name: "auth" } },
      { path: "adm", redirect: { name: "auth" } },
      {
        path: "auth",
        name: "auth",
        component: () => import("pages/Auth.vue"),
      },
      {
        path: "settings",
        component: () => import("pages/Settings.vue"),
      },
      {
        path: "changes",
        component: () => import("pages/Changes.vue"),
        meta: { requiresAuth: true },
      },
      ...chat_routes,
      {
        path: "rec",
        component: () => import("layouts/EmptyLayout.vue"),
        meta: { requiresAuth: true },
        children: [...rec_routes],
      },
      {
        path: "tts",
        component: () => import("layouts/EmptyLayout.vue"),
        meta: { requiresAuth: true },
        children: [...tts_routes],
      },
      {
        path: "operator",
        component: () => import("layouts/EmptyLayout.vue"),
        meta: { requiresAuth: true },
        children: [...operator_routes],
      },
      {
        path: "kb",
        component: () => import("layouts/EmptyLayout.vue"),
        meta: { requiresAuth: true },
        children: [...kb_routes],
      },
      {
        path: "gmc",
        component: () => import("layouts/EmptyLayout.vue"),
        meta: { requiresAuth: true },
        children: [...gmc_routes],
      },
      {
        path: "sip",
        component: () => import("layouts/EmptyLayout.vue"),
        meta: { requiresAuth: true },
        children: [...sip_routes],
      },
      {
        path: "ma",
        component: () => import("layouts/EmptyLayout.vue"),
        meta: { requiresAuth: true },
        children: [...ma_routes],
      },
      {
        path: "game",
        component: () => import("layouts/EmptyLayout.vue"),
        meta: { requiresAuth: true },
        children: [...game_routes],
      },
      {
        path: "dsgraph",
        component: () => import("layouts/EmptyLayout.vue"),
        meta: { requiresAuth: true },
        children: [...dsgraph_routes],
      },
      {
        path: "dm",
        component: () => import("layouts/EmptyLayout.vue"),
        meta: { requiresAuth: true },
        children: [...data_master_routes],
      },
      {
        path: "dataset",
        component: () => import("layouts/EmptyLayout.vue"),
        meta: { requiresAuth: true },
        children: [...dataset_routes],
      },
      {
        path: "cube",
        component: () => import("layouts/EmptyLayout.vue"),
        meta: { requiresAuth: true },
        children: [...cube_routes],
      },
      {
        path: "tlgrm",
        component: () => import("layouts/EmptyLayout.vue"),
        meta: { requiresAuth: true },
        children: [...idom_routes],
      },
      {
        path: "loms",
        component: () => import("layouts/EmptyLayout.vue"),
        meta: { requiresAuth: true },
        children: [...loms_routes],
      },
      {
        path: "idom-mediaplans",
        component: () => import("layouts/EmptyLayout.vue"),
        meta: {
          requiresAuth: true,
        },
        children: [...mediaplans_routes],
      },
      {
        path: "idom-statistic",
        component: () => import("layouts/EmptyLayout.vue"),
        meta: { requiresAuth: true },
        children: [...idom_statistic_routes],
      },
      {
        path: "idom-mem",
        component: () => import("layouts/EmptyLayout.vue"),
        meta: { requiresAuth: true },
        children: [...idom_mem_routes],
      },
      {
        path: "idom-reaction",
        component: () => import("layouts/EmptyLayout.vue"),
        meta: { requiresAuth: true },
        children: [...idom_reaction_routes],
      },
      {
        path: "idom-tasks",
        component: () => import("layouts/EmptyLayout.vue"),
        meta: { requiresAuth: true },
        children: [...idom_tasks_routes],
      },
      {
        path: "idom-settings",
        component: () => import("layouts/EmptyLayout.vue"),
        meta: { requiresAuth: true },
        children: [...idom_settings_routes],
      },
      {
        path: "integrations",
        component: () => import("layouts/EmptyLayout.vue"),
        meta: { requiresAuth: true },
        children: [...integrations_routes],
      },
    ],
  },
  {
    path: "/speech_demo",
    component: () => import("layouts/SingleLayout.vue"),
    children: [
      {
        path: "",
        component: () => import("pages/DemoGenerationProfiles.vue"),
      },
    ],
  },
  {
    path: "/front",
    component: () => import("layouts/EmptyLayout.vue"),
    children: [...front_routes],
  },
  {
    path: "/empty",
    component: () => import("layouts/EmptyLayout.vue"),
    children: [...empty_routes],
  },
  {
    path: "/utils",
    component: () => import("layouts/EmptyLayout.vue"),
    children: [...utils_routes],
  },

  // Always leave this as last one,
  // but you can also remove it
  {
    path: "/403",
    name: "403",
    component: () => import("pages/Error403.vue"),
  },
  {
    path: "/:catchAll(.*)*",
    component: () => import("pages/Error404.vue"),
  },
];

export default routes;
